module.exports = __webpack_public_path__ + "img/sld_scb_33_t1_b1_green.f816b208.svg";